module.exports = __webpack_public_path__ + "img/no-prize.f1e28c85.png";